import { createAction } from 'redux-actions';
import { OrderAdditionalServicesFragment } from '@websky/graphql';

export const setAdditionalServices = createAction<OrderAdditionalServicesFragment>('SET_ADDITIONAL_SERVICES');

export type SetAdditionalServicesAction = ReturnType<typeof setAdditionalServices>;
